import { cn } from "@/lib/utils"

function Kbd({ className, ...props }: React.ComponentProps<"kbd">) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        "pointer-events-none inline-flex h-5 w-fit min-w-5 items-center justify-center gap-1 rounded px-1.5 font-mono text-[10px] font-medium select-none",
        "bg-gray-100 text-gray-500 border border-gray-200",
        "[&_svg:not([class*='size-'])]:size-3",
        "[[data-slot=tooltip-content]_&]:bg-white/20 [[data-slot=tooltip-content]_&]:text-white [[data-slot=tooltip-content]_&]:border-white/30",
        className
      )}
      {...props}
    />
  )
}

export { Kbd }
